// axios
import axios from 'axios'

const baseURL = 'https://api.personal-finance.madfariz.my.id/api/'

export default axios.create({
  baseURL
})
